import React from 'react'
import { Box, ClickAwayListener, Grow, ListItemText, makeStyles, MenuItem, MenuList, Paper, Popper } from '@material-ui/core'

const useStyle = makeStyles((theme) => ({
    paper: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderRadius: "4px",
    },
    boxSubmenu: {
        "&::before": {
            content: '""',
            position: "absolute",
            width: "0",
            height: "0",
            bottom: -15,
            right: 10,
            border: "8px solid",
            borderColor: "transparent",
            borderTopColor: theme.palette.primary.main,
            zIndex: 9999
        }
    },
    smallText: {
        fontSize: 14
    }
}))

export default function AddQuestionPopperComponent({
    isOpen,
    anchorRef,
    handleClick,
    handleClose,
    options
}) {
    const classes = useStyle()

    return (
        <Popper
            open={isOpen}
            anchorEl={anchorRef.current}
            role={undefined}
            style={{
                zIndex: 9999,
            }}
            transition
            placement="top-end"
            popperOptions={{
                modifiers: {
                    offset: {
                        offset: '0,10',
                    },
                },
            }}
        >
            {({ TransitionProps }) => {
                return (
                    <Grow
                        {...TransitionProps}
                    >
                        <Box className={classes.boxSubmenu}>
                            <Paper className={classes.paper}>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList
                                        autoFocusItem={isOpen}
                                        id="menu-list-grow"
                                    >
                                        {options.map((item, index) => (
                                            <MenuItem
                                                key={index}
                                                style={{ fontSize: "small" }}
                                                onClick={() => handleClick(item)}
                                            >
                                                <ListItemText primary={item.label} classes={{ primary: classes.smallText }} />
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Box>
                    </Grow>
                )
            }}
        </Popper>
    )
}
